import { __decorate, __param, __metadata } from 'tslib';
import { Optional, ɵɵdefineInjectable, ɵɵinject, Injectable, Component, SkipSelf, NgModule } from '@angular/core';
import { StorageMap, StorageModule } from '@ngx-pwa/local-storage';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MiaHttpService } from '@mobileia/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@ngx-pwa/local-storage';
import * as ɵngcc3 from '@angular/router';
class MIAAccessToken {
}

class MIAUser {
}

class AuthenticationServiceConfig {
    constructor() {
        this.apiKey = '';
        this.isInternal = false;
        this.baseUrlInternal = '';
    }
}
let AuthenticationService = class AuthenticationService {
    constructor(http, storage, config) {
        this.http = http;
        this.storage = storage;
        this._baseUrl = 'https://authentication.mobileia.com/api/';
        this._baseUrlInternal = '';
        this._isInternal = false;
        this._keyAccessToken = 'key_access_token';
        this._keyUserId = 'key_user_id';
        this._keyUserData = 'key_user_data';
        this._apiKey = '';
        if (config) {
            this._apiKey = config.apiKey;
        }
        if (config && config.baseUrlInternal) {
            this._baseUrlInternal = config.baseUrlInternal;
        }
        if (config && config.isInternal) {
            this._isInternal = config.isInternal;
        }
        // Creamos observable de la variable que informa que se loguea
        this.isLoggedIn = new BehaviorSubject(false);
        // Creamos observable para el usuario logueado
        this.currentUser = new BehaviorSubject(null);
        // Verificar si esta logueado
        this.getAccessToken().subscribe(accessToken => {
            if (accessToken == null) {
                return;
            }
            if (this._isInternal) {
                // Esta logueado
                this.isLoggedIn.next(true);
                // Buscar datos del usuario
                this.getUserData().subscribe(data => {
                    // Guardar datos de perfil
                    this.currentUser.next(data);
                });
            }
            else {
                // Cargar profile
                this.loadProfile();
            }
        });
    }
    signInWithGoogle(authToken, googleToken) {
        const params = {
            grant_type: 'google',
            app_id: this._apiKey,
            auth_token: authToken,
            google_token: googleToken
        };
        return this.http.post(this._baseUrl + 'oauth', params)
            .pipe(map(data => {
            // Verificar si se logueo correctamente
            if (data.success) {
                // Guardar AccessToken
                this.storage.set(this._keyAccessToken, data.response.access_token).subscribe(() => {
                    // Buscar datos del perfil
                    this.loadProfile();
                });
                this.storage.set(this._keyUserId, data.response.user_id).subscribe(() => { });
                // Guardar que esta logueado
                this.isLoggedIn.next(true);
            }
            return data;
        }));
    }
    signInWithFacebook(facebookId, facebookToken) {
        const params = {
            grant_type: 'facebook',
            app_id: this._apiKey,
            facebook_id: facebookId,
            facebook_access_token: facebookToken
        };
        return this.http.post(this._baseUrl + 'oauth', params)
            .pipe(map(data => {
            // Verificar si se logueo correctamente
            if (data.success) {
                // Guardar AccessToken
                this.storage.set(this._keyAccessToken, data.response.access_token).subscribe(() => {
                    // Buscar datos del perfil
                    this.loadProfile();
                });
                this.storage.set(this._keyUserId, data.response.user_id).subscribe(() => { });
                // Guardar que esta logueado
                this.isLoggedIn.next(true);
            }
            return data;
        }));
    }
    signInWithEmailAndPasswordInternal(email, password) {
        const params = {
            email: email,
            password: password
        };
        return this.http.post(this._baseUrlInternal + 'mia-auth/login', params)
            .pipe(map(data => {
            // Verificar si se logueo correctamente
            if (data.success) {
                // Guardar AccessToken
                this.storage.set(this._keyAccessToken, data.response.access_token.access_token).subscribe(() => { });
                this.storage.set(this._keyUserId, data.response.access_token.user_id).subscribe(() => { });
                this.storage.set(this._keyUserData, JSON.stringify(data.response.user)).subscribe(() => { });
                // Guardar que esta logueado
                this.isLoggedIn.next(true);
            }
            return data;
        }));
    }
    registerInternal(user, password) {
        let params = user;
        params.password = password;
        params.platform = 2;
        return this.http.post(this._baseUrlInternal + 'mia-auth/register', params);
    }
    signInWithEmailAndPassword(email, password) {
        const params = {
            grant_type: 'normal',
            app_id: this._apiKey,
            email: email,
            password: password
        };
        return this.http.post(this._baseUrl + 'oauth', params)
            .pipe(map(data => {
            // Verificar si se logueo correctamente
            if (data.success) {
                // Guardar AccessToken
                this.storage.set(this._keyAccessToken, data.response.access_token).subscribe(() => {
                    // Buscar datos del perfil
                    this.loadProfile();
                });
                this.storage.set(this._keyUserId, data.response.user_id).subscribe(() => { });
                // Guardar que esta logueado
                this.isLoggedIn.next(true);
            }
            return data;
        }));
    }
    loadProfile() {
        this.fetchProfile().subscribe(data => { });
    }
    fetchProfile() {
        // Obtenemos AccessToken
        return this.getAccessToken().pipe(switchMap(accessToken => {
            if (accessToken == null) {
                return;
            }
            return this.requestProfile(accessToken);
        }));
    }
    requestProfile(accessToken) {
        const params = {
            access_token: accessToken,
            app_id: this._apiKey
        };
        return this.http.post(this._baseUrl + 'me', params)
            .pipe(map(data => {
            // Verificar si el AccessToken es incorrecto cerrar sesión
            if (!data.success && data.error && data.error.code == 413) {
                this.signOut();
                window.location.reload();
            }
            // Verificar si fue correcto
            if (data.success) {
                // Guardar datos del usuario en la DB local
                this.storage.set(this._keyUserData, JSON.stringify(data.response)).subscribe(() => { });
                // Guardar datos de perfil
                this.currentUser.next(data.response);
                // Esta logueado
                this.isLoggedIn.next(true);
            }
            // Devolvemos Observable
            return data;
        }));
    }
    registerUserWithFacebook(params) {
        // Verificar si tiene foto asignada
        let photo = '';
        if (params.photo) {
            photo = params.photo;
        }
        const postParams = {
            app_id: this._apiKey,
            register_type: 'facebook',
            facebook_id: params.facebookId,
            facebook_access_token: params.facebookToken,
            platform: 2
        };
        return this.http.post(this._baseUrl + 'register', postParams);
    }
    registerUser(params) {
        // Verificar si tiene foto asignada
        let photo = '';
        if (params.photo) {
            photo = params.photo;
        }
        let phone = '';
        if (params.phone) {
            phone = params.phone;
        }
        const postParams = {
            app_id: this._apiKey,
            register_type: 'normal',
            email: params.email,
            password: params.password,
            firstname: params.firstname,
            lastname: params.lastname,
            photo: photo,
            phone: phone,
            platform: 2
        };
        return this.http.post(this._baseUrl + 'register', postParams);
    }
    updateUser(params) {
        // Obtenemos AccessToken
        return this.getAccessToken().pipe(switchMap(accessToken => {
            if (accessToken == null) {
                return;
            }
            // Asignar APP ID
            params.app_id = this._apiKey;
            params.access_token = accessToken;
            return this.http.post(this._baseUrl + 'update', params);
        }));
    }
    recoveryPass(email, newPassword) {
        const params = {
            app_id: this._apiKey,
            email: email,
            password: newPassword,
            platform: 2
        };
        return this.http.post(this._baseUrl + 'recovery', params);
    }
    saveDataLoginInternal(accessToken, userId, user) {
        this.storage.set(this._keyAccessToken, accessToken).subscribe(() => { });
        this.storage.set(this._keyUserId, userId).subscribe(() => { });
        this.storage.set(this._keyUserData, JSON.stringify(user)).subscribe(() => { });
        // Sincronizar dato del usuario
        this.currentUser.next(user);
    }
    signOut() {
        this.storage.delete(this._keyAccessToken).subscribe(() => { });
        this.storage.delete(this._keyUserId).subscribe(() => { });
        this.storage.delete(this._keyUserData).subscribe(() => { });
        this.storage.clear().subscribe(() => { });
        this.isLoggedIn.next(false);
        this.currentUser.next(null);
    }
    saveAccesstoken(accessToken) {
        // Guardar AccessToken
        this.storage.set(this._keyAccessToken, accessToken).subscribe(() => {
            // Buscar datos del perfil
            this.loadProfile();
        });
    }
    /**
     * Devuelve API Key
     */
    getApiKey() {
        return this._apiKey;
    }
    getAccessToken() {
        return this.storage.get(this._keyAccessToken, { type: 'string' });
    }
    getUserID() {
        return this.storage.get(this._keyUserId, { type: 'number' });
    }
    getUserData() {
        return this.storage.get(this._keyUserData, { type: 'string' }).pipe(map(data => JSON.parse(data)));
    }
};
AuthenticationService.ɵfac = function AuthenticationService_Factory(t) { return new (t || AuthenticationService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.StorageMap), ɵngcc0.ɵɵinject(AuthenticationServiceConfig, 8)); };
AuthenticationService.ctorParameters = () => [
    { type: HttpClient },
    { type: StorageMap },
    { type: AuthenticationServiceConfig, decorators: [{ type: Optional }] }
];
AuthenticationService.ɵprov = ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(ɵɵinject(HttpClient), ɵɵinject(StorageMap), ɵɵinject(AuthenticationServiceConfig, 8)); }, token: AuthenticationService, providedIn: "root" });
AuthenticationService = __decorate([ __param(2, Optional()),
    __metadata("design:paramtypes", [HttpClient,
        StorageMap,
        AuthenticationServiceConfig])
], AuthenticationService);

let AuthenticationComponent = class AuthenticationComponent {
    constructor() { }
    ngOnInit() {
    }
};
AuthenticationComponent.ɵfac = function AuthenticationComponent_Factory(t) { return new (t || AuthenticationComponent)(); };
AuthenticationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthenticationComponent, selectors: [["lib-authentication"]], decls: 2, vars: 0, template: function AuthenticationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " authentication works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
AuthenticationComponent = __decorate([ __metadata("design:paramtypes", [])
], AuthenticationComponent);

var AuthenticationModule_1;
let AuthenticationModule = AuthenticationModule_1 = class AuthenticationModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('AuthenticationModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot(config) {
        return {
            ngModule: AuthenticationModule_1,
            providers: [
                { provide: AuthenticationServiceConfig, useValue: config }
            ]
        };
    }
};
AuthenticationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AuthenticationModule });
AuthenticationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AuthenticationModule_Factory(t) { return new (t || AuthenticationModule)(ɵngcc0.ɵɵinject(AuthenticationModule, 12)); }, providers: [], imports: [[
            HttpClientModule,
            StorageModule.forRoot({ IDBNoWrap: true })
        ]] });
AuthenticationModule.ctorParameters = () => [
    { type: AuthenticationModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
AuthenticationModule = AuthenticationModule_1 = __decorate([ __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [AuthenticationModule])
], AuthenticationModule);

let AuthGuard = class AuthGuard {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    canActivate(next, state) {
        const reply = this.authService.isLoggedIn;
        reply.subscribe(isLogged => {
            if (!isLogged) {
                let paramRedirect = window.location.pathname;
                if (paramRedirect.includes('login')) {
                    paramRedirect = null;
                }
                // Navigate to the login page with extras
                this.router.navigate(['/login'], { queryParams: { redirect: paramRedirect } });
            }
        });
        return reply;
    }
};
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵngcc0.ɵɵinject(AuthenticationService), ɵngcc0.ɵɵinject(ɵngcc3.Router)); };
AuthGuard.ctorParameters = () => [
    { type: AuthenticationService },
    { type: Router }
];
AuthGuard.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(ɵɵinject(AuthenticationService), ɵɵinject(Router)); }, token: AuthGuard, providedIn: "root" });
AuthGuard = __decorate([ __metadata("design:paramtypes", [AuthenticationService, Router])
], AuthGuard);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.StorageMap }, { type: AuthenticationServiceConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationComponent, [{
        type: Component,
        args: [{
                selector: 'lib-authentication',
                template: `
    <p>
      authentication works!
    </p>
  `
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthenticationModule, { declarations: function () { return [AuthenticationComponent]; }, imports: function () { return [HttpClientModule, ɵngcc2.StorageModule]; }, exports: function () { return [AuthenticationComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule,
                    StorageModule.forRoot({ IDBNoWrap: true })
                ],
                declarations: [AuthenticationComponent],
                exports: [AuthenticationComponent],
                providers: []
            }]
    }], function () { return [{ type: AuthenticationModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthenticationService }, { type: ɵngcc3.Router }]; }, null); })();

class MiaAuthHttpService extends MiaHttpService {
    constructor(http, authService) {
        super(http);
        this._httpReference = http;
        this._authServiceReference = authService;
    }
    postAuthObject(url, params) {
        return this._authServiceReference.getAccessToken().pipe(switchMap(token => {
            params.access_token = token;
            return this.postObject(url, params);
        }));
    }
    postAuthArray(url, params) {
        return this._authServiceReference.getAccessToken().pipe(switchMap(token => {
            params.access_token = token;
            return this.postArray(url, params);
        }));
    }
    requestAuthObject(url, params, callback) {
        this._authServiceReference.getAccessToken().subscribe(token => {
            params.access_token = token;
            this.requestObject(url, params, callback);
        });
    }
    requestAuthArray(url, params, callback) {
        this._authServiceReference.getAccessToken().subscribe(token => {
            params.access_token = token;
            this.requestArray(url, params, callback);
        });
    }
}

/*
 * Public API Surface of authentication
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthGuard, AuthenticationComponent, AuthenticationModule, AuthenticationService, AuthenticationServiceConfig, MIAAccessToken, MIAUser, MiaAuthHttpService };

//# sourceMappingURL=mobileia-authentication.js.map